import { graphql, readFragment, useQuery } from "@opensea/graphql";
import { Avatar } from "@opensea/next-ui-kit";
import { FlexCenter, formatAddress, TextBody, TooltipLabel } from "@opensea/ui-kit";
import { Verified } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { PreviewTooltipContent } from "@/components/tooltip/PreviewTooltip";
import { ProfileMetadataChips } from "../ProfileMetadataChips";
import { ProfileMetadataChipsFragment } from "../ProfileMetadataChips/ProfileMetadataChips.fragment";
import { ProfilePreviewTooltipCollectionTable } from "./CollectionTable/ProfilePreviewTooltipCollectionTable";
import { ProfilePreviewTooltipCollectionTableFragment } from "./CollectionTable/ProfilePreviewTooltipCollectionTable.fragment";
import { ProfilePreviewTooltipContentFragment } from "./ProfilePreviewTooltipContent.fragment";
import { ProfilePreviewTooltipContentSkeleton } from "./ProfilePreviewTooltipContentSkeleton";
import { ProfilePreviewTooltipLayout } from "./ProfilePreviewTooltipLayout";
const query = graphql(`
    query ProfilePreviewTooltipContentQuery($address: Address!) {
      profileByAddress(address: $address) {
        __typename
        ... on Profile {
          address
          displayName
          imageUrl
          isVerified
          ...ProfileMetadataChips
        }
      }
      profileCollections(addresses: [$address], limit: 3) {
        items {
          __typename
          ...ProfilePreviewTooltipCollectionTable
        }
      }
    }
  `, [ProfileMetadataChipsFragment, ProfilePreviewTooltipCollectionTableFragment]);
export const ProfilePreviewTooltipContent = withSuspense(function ProfilePreviewTooltipContent({
  profile: profileKey
}) {
  const {
    address
  } = readFragment(ProfilePreviewTooltipContentFragment, profileKey);
  const [{
    data
  }] = useQuery({
    query,
    variables: {
      address
    }
  });
  const t = useTranslations("ProfilePreviewTooltipContent");
  if (data?.profileByAddress.__typename === "Profile") {
    const profile = data.profileByAddress;
    const collections = data.profileCollections.items;
    return <ProfilePreviewTooltipLayout avatar={<Avatar border rounded seed={profile.address} size={46} src={profile.imageUrl} />} chips={<ProfileMetadataChips chips={["address", "beta_tester"]} profile={profile} variant="compact" />} collectionsTable={<ProfilePreviewTooltipCollectionTable collections={collections} />} name={<FlexCenter className="gap-1.5">
              <TextBody size="md" weight="semibold">
                {profile.displayName || formatAddress(profile.address)}
              </TextBody>
              {profile.isVerified ? <Verified size={16} /> : null}
            </FlexCenter>} showCollectionsTable={collections.length > 0} />;
  }
  return <PreviewTooltipContent>
        <TooltipLabel>{t("error")}</TooltipLabel>
      </PreviewTooltipContent>;
}, {
  fallback: <ProfilePreviewTooltipContentSkeleton />
});